import React from 'react';
import SMRestClient from 'lib/SMRestClient';
import SMSearchHelper from 'components/helpers/SMSearchHelper';
import SMSearchListFormView from './SMSearchListFormView';
import SMSearchListSortView from './SMSearchListSortView';
import SMSearchListTableRow from './SMSearchListTableRow';
import SMSearchPagerView from './SMSearchPagerView';
import SMSearchMapView from './SMSearchMapView';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import 'react-mdl/extra/material.js';
import {Textfield} from 'react-mdl';
import SMConst from 'lib/SMConst';
import SMRoomResource from 'resources/SMRoomResource';
import SMHistoryHelper from 'components/helpers/SMHistoryHelper';
import SMUserResource from 'resources/SMUserResource';
import SMRoomAreaResource from 'resources/SMRoomAreaResource';
import SMMapHelper from 'components/helpers/SMMapHelper';
import SMUFavoriteListSelectView from 'components/dashboard/users/SMUFavoriteListSelectView';
import moment from 'moment';

class SMSearchListView extends React.Component {

  constructor(props) {
    super(props);

    this.canRequest = true;

    this.state = {
      listItems: this.props.rooms,
      totalCount: this.props.totalCount,
      links: SMRestClient.parseLinkString(this.props.linkString),
      display: this.props.display,
      pushStateUrl: "",
      mobileTabIndex: 1,
      mouseEnterRoom: null,
      isOpenFilter: false,
      keyword: this.props.keyword || '',
      location: this.props.location,
      geocode: this.props.geocode || '',
      eventType: this.props.eventType || '',
      spaceType: this.props.spaceType || '',
      capacity: this.props.capacity || '',
      amenities: this.props.amenities || '',
      minPrice: this.props.minPrice || '',
      maxPrice: this.props.maxPrice || '',
      minCapacity: this.props.minCapacity || '',
      maxCapacity: this.props.maxCapacity || '',
      priceType: this.props.priceType || '',
      startedAt: this.props.startedAt || '',
      startedHour: this.props.startedHour || '',
      endedAt: this.props.endedAt || '',
      endedHour: this.props.endedHour || '',
      roomId: this.props.roomId || '',
      stayCheckinAt: this.props.stayCheckinAt || '',
      stayCheckoutAt: this.props.stayCheckoutAt || '',
      hasDirectReservationPlans: this.props.hasDirectReservationPlans || '',
      hasLastMinuteDiscountPlans: '',
      isFilterByPrefecture: true,
      isClickedAreaSearch: false,
      sort: this.props.sort,
      currentPage: this.props.currentPage,
      isTabView: false,
      isCheckedMapMoveSearch: false,
      isMovedMap: false, //マップを動かした際にtrueにする(エリア検索時のマップ移動ではfalse)
      temporaryLatitude: '', //マップ移動検索しない時の現在Position格納用(latitude)
      temporaryLongitude: '', //マップ移動検索しない時の現在Position格納用(logitude)
      temporaryZoom: '', //マップ移動検索しない時の現在Zoom格納用
      temporaryGeocode: '', //エリア検索時のAPI側に問い合わせる際のGeocode
      searchSessionId: this.props.searchSessionId, // ユーザのひとまとまりの検索行動を識別するためのid
      targetFavoriteRoom: {},
      latestUpdatedFavoriteList: {},
      isNewQuery: true,
      withRecommend: this.props.withRecommend,
      isSMUFavoriteListSelectViewOpen: false,
    };

    const featureAmenityList = SMSearchHelper.featureAmenityList(this.props.eventType, this.props.amenityList);
    this.amenityList = [];
    this.props.amenityList.forEach((amenity)=>{
      let isFeature = false;
      featureAmenityList.some((feature)=>{
        if (amenity.id == feature.id) {
          isFeature = true;
          return true;
        }
      });
      if (isFeature) return;
      this.amenityList.push(amenity);
    });
    this.amenityList = featureAmenityList.concat(this.amenityList);
  }

  toQuery() {
    return({
      keyword: this.state.keyword,
      location: this.state.location,
      geocode: this.state.geocode,
      event_type: this.state.eventType,
      space_type: this.state.spaceType,
      capacity: this.state.capacity,
      amenities: this.state.amenities,
      min_price: this.state.minPrice,
      max_price: this.state.maxPrice,
      min_capacity: this.state.minCapacity,
      max_capacity: this.state.maxCapacity,
      price_type: this.state.priceType,
      started_at: this.state.startedAt,
      ended_at: this.state.endedAt,
      started_hour: this.state.startedHour,
      ended_hour: this.state.endedHour,
      stay_checkin_at: this.state.stayCheckinAt,
      stay_checkout_at: this.state.stayCheckoutAt,
      room_id: this.state.roomId,
      has_direct_reservation_plans: this.state.hasDirectReservationPlans,
      has_last_minute_discount_plans: this.state.hasLastMinuteDiscountPlans,
      filter_by_prefecture: this.state.isFilterByPrefecture,
      sort: this.state.sort,
      search_session_id: this.state.searchSessionId,
      is_new_query: this.state.isNewQuery,
      with_recommend: this.state.withRecommend,
    });
  }

  componentDidMount() {
    SMRenderHelper.addObserverForBaloon();
    SMTrackHelper.criteoList(this.props.currentUser ? this.props.currentUser.email : "", this.props.rooms);

    if (SMAppHelper.isTablet()) {
      setTimeout(()=>{
        this.setState({isTabView: true});
      }, 1);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.pushStateUrl != prevState.pushStateUrl) {
      SMHistoryHelper.replaceState(this.state.pushStateUrl, this.state);
      //SMAppHelper.setTitle(sprintf(I18n.t("dashboard.label_000116"), reservation.id));
    }
  }

  queriesDidChange(queries) {
    let state = {
      currentPage: 1,
    };
    this.setState(Object.assign(state, queries));

    if (!this.state.isOpenFilter) {
      setTimeout(()=>{
        this.requestResource();
      },1);
      SMTrackHelper.pageView();
    }
  }

  // SMSearchListTableRow delegate
  favoriteDidSelect(favorable, isFavorite, rowIndex) {
    if (!this.props.currentUser) {
      SMAppHelper.redirectToLogin();
    }
    if (isFavorite) {
      // もしお気に入りに登録されている場合はリスト選択のモーダルを表示
      this.showFavoriteListSelectForm(favorable);
    } else {
      let room = favorable;
      let responseHandler = (data, error, xhr)=>{
        let listItems = this.state.listItems;
        if (error) {
          return;
        } else {
          room.is_favorite = true;
          room.registered_favorite_lists.push(data.favorite_list.id);
          listItems[rowIndex] = room;
          this.setState({
            listItems: listItems,
            latestUpdatedFavoriteList: data.favorite_list,
          });
        }
      };
      SMUserResource.postFavorite(this.props.currentUser.username, room.id, 'Room', responseHandler);
    }
  }


  showFavoriteListSelectForm(room, e){
    if (e) e.preventDefault();
    this.setState({
      targetFavoriteRoom: room,
      isSMUFavoriteListSelectViewOpen: true,
    });
  }

  // SMSearchListTableRow delegate
  favoriteListSelectViewDidClose() {
    this.setState({
      isSMUFavoriteListSelectViewOpen: false,
    });
  }

  // SMSearchMapView delegate
  favoriteDidSelectOnMap(room) {
    this.showFavoriteListSelectForm(room);
  }


  // SMSearchListTableRow delegate
  imageDidMouseEnter(room) {
    this.setState({mouseEnterRoom: room});
  }

  // SMSearchListTableRow delegate
  imageDidMouseLeave(room) {
    this.setState({mouseEnterRoom: null});
  }

  requestResource(isAppend, callback) {
    if (!this.canRequest) return;
    this.canRequest = false;
    if (!isAppend) this.setState({display: SMConst.Display.Loading});

    const currentQueries = this.toQuery();
    let queries = {};
    for (let name in currentQueries) {
      const value = currentQueries[name];
      if (value) {
        queries[name] = value;
      }
    }
    if (this.state.temporaryGeocode) {
      queries['geocode'] = this.state.temporaryGeocode;
    }

    if (this.state.currentPage != 1) queries.page = this.state.currentPage;
    const pushStateUrl = Routes.search_index_path(queries);

    // exclude url
    if (queries.sort && queries.sort != "popular") {
      queries.exclude_crawl_spaces = true;
    }
    queries.period_unit = this.state.priceType;
    queries.allow_rent_types = this.state.eventType == 'stay' ? 'stay' : 'daytime';
    queries.per_page = this.props.perPage;

    if (this.state.withRecommend == null || this.state.withRecommend == undefined) {
      queries.with_recommend = true;
      this.setState({withRecommend: true});
    }

    if (SMAppHelper.isTablet()) {
      $(window).scrollTop(0);
    } else {
      $(this.refs.listScroller).scrollTop(0);
    }
    $(this.refs.listContainer).startLoading();
    SMRoomResource.search(queries, (responses, error, xhr)=>{
      this.canRequest = true;
      $(this.refs.listContainer).stopLoading();
      this.setState({display: SMConst.Display.Visible});
      if(error || !responses) return;
      const links = SMRestClient.getLinks(xhr);
      //let listItems = this.state.listItems;
      //listItems = React.addons.update(listItems, {$push: responses});

      let state = {
        links: links,
        listItems: responses,
        totalCount: xhr.getResponseHeader('X-List-Total-Count'),
        searchSessionId: xhr.getResponseHeader('X-Search-Session-Id'),
        isNewQuery: true,
      };
      if (!isAppend) state.pushStateUrl = pushStateUrl;
      this.setState(state);

      responses.forEach((room, index) => {
        ga('ec:addImpression', {
          id: room.id,
          category: `${room.space.country_alpha2}/${room.space.state}/${room.space.space_type}`,
          brand: room.owner.id,
          list: 'SearchList',
          position: (this.state.currentPage - 1) * this.props.perPage + index,
          dimension1: 'Room'
        });
      });
      ga('send', 'event', 'Ecommerce', 'addImpression', {'nonInteraction': 1});
    });

    // geocode
    // エリア以外の値を変更した際にマップの位置が絞り込まれて使いづらいのでエリア検索の値を触れた時にマップの中央位置を変更する
    if (
      this.state.location != null &&
      this.state.location != '' &&
      this.state.isFilterByPrefecture &&
      this.state.isClickedAreaSearch
    ) {
      SMRoomAreaResource.search(queries, (responses, error, xhr) => {
        if (error || !responses) {
          return;
        }
        const result = `${responses.latitude},${responses.longitude},${responses.radius}`;

        this.setState({
          geocode: result,
          isClickedAreaSearch: false,
          temporaryGeocode: null,
        });
      });
    }

  }

  pageDidSelect(page, e) {
    e.preventDefault();
    this.queriesDidChange({currentPage: page, isNewQuery: false});
  }

  sortDidChangeValue(value) {
    this.queriesDidChange({sort: value});
  }

  startedAtDidSelect(startedAt) {
    let state = {};
    state.startedAt = startedAt;
    this.queriesDidChange(state);
  }

  startedHourDidSelect(startedAt, startedHour) {
    let state = {};
    state.startedAt = startedAt;
    state.startedHour = startedHour;
    this.queriesDidChange(state);
  }

  changedDateAndHour(startedAt, endedAt, startedHour, endedHour) {
    let state = {};
    state.startedAt = startedAt;
    state.endedAt = endedAt;
    state.startedHour = startedHour;
    state.endedHour = endedHour;
    this.queriesDidChange(state);
  }

  endedAtDidSelect(endedAt) {
    let state = {};
    state.endedAt = endedAt;
    this.queriesDidChange(state);
  }

  endedHourDidSelect(startedAt, endedHour) {
    let state = {};
    state.endedHour = endedHour;
    state.startedAt = startedAt;
    this.queriesDidChange(state);
  }

  capacityDidSelect(capacity) {
    this.queriesDidChange({capacity: capacity});
  }

  priceTypeDidSelect(priceType, startedAt, endedAt) {
    this.queriesDidChange({
      priceType: priceType,
      startedAt: startedAt,
      endedAt: endedAt,
    });
  }

  spaceTypeDidSelect(e) {
    this.queriesDidChange({spaceType: e.currentTarget.value});
  }

  locationDidSelect(geocode, location) {
    let state = {};
    state.geocode = null;
    state.location = location;
    state.isFilterByPrefecture = true;
    this.setState({
      isClickedAreaSearch: true,
      temporaryLatitude: null,
      temporaryLongitude: null,
      temporaryZoom: null,
      temporaryGeocode: geocode,
    });
    this.queriesDidChange(state);
  }

  mapCenterDidChange(position) {
    const lat = position.lat();
    const lng = position.lng();

    if (this.state.isCheckedMapMoveSearch) {
      let state = {};
      let geocodes = this.state.geocode.split(",");
      const radius = (geocodes.length == 3) ? parseFloat(geocodes[2]) : SMMapHelper.getRadiusByZoom(8);
      state.geocode = SMMapHelper.getGeocode(lat, lng, radius);
      state.isFilterByPrefecture = false;
      this.queriesDidChange(state);
    }

    this.setState({
      isMovedMap: true,
      temporaryLatitude: lat,
      temporaryLongitude: lng,
    });
  }

  mapZoomDidChange(zoom, position) {
    let lat = position.lat();
    let lng = position.lng();

    if (this.state.isCheckedMapMoveSearch) {
      const radius = SMMapHelper.getRadiusByZoom(zoom);
      if (radius) {
        let geocodes = this.state.geocode.split(',');

        if (geocodes != '') {
          lat = geocodes[0];
          lng = geocodes[1];
        }

        this.queriesDidChange({
          geocode: SMMapHelper.getGeocode(lat, lng, radius),
          isFilterByPrefecture: false,
        });
      }
    }
    this.setState({
      isMovedMap: true,
      temporaryZoom: zoom,
      temporaryLatitude: lat,
      temporaryLongitude: lng,
    });
  }

  changeTabMobile(mobileTabIndex, e) {
    e.preventDefault();
    this.setState({mobileTabIndex: mobileTabIndex});
  }

  minPriceRangeDidChange(value) {
    this.setState({minPrice: value});
  }

  maxPriceRangeDidChange(value) {
    this.setState({maxPrice: value});
  }

  clearPriceRange() {
    let state = {
      minPrice: '',
      maxPrice: '',
    };
    this.queriesDidChange(state);
  }

  priceRangeDidBlur(name, value) {
    let state = {};
    state[name] = value;
    this.queriesDidChange(state);
  }

  minCapacityRangeDidChange(value) {
    const state = {minCapacity: value};
    this.queriesDidChange(state);
  }

  maxCapacityRangeDidChange(value) {
    const state = {maxCapacity: value};
    this.queriesDidChange(state);
  }

  clearCapacityRange() {
    const state = {
      minCapacity: '',
      maxCapacity: '',
    };
    this.queriesDidChange(state);
  }

  keywordDidChange(e) {
    this.queriesDidChange({keyword: e.currentTarget.value});
  }

  amenityDidSelect(e){
    const value = e.currentTarget.value;
    this.manageSelectedAmenities(value);
  }

  directReservationDidSelect(value){
    this.queriesDidChange({hasDirectReservationPlans: value});
  }

  lastMinuteDiscountDidSelect(e){
    const value = !this.state.hasLastMinuteDiscountPlans || '';
    this.queriesDidChange({hasLastMinuteDiscountPlans: value});
  }

  manageSelectedAmenities(name){
    let names = this.state.amenities ? this.state.amenities.split(",") : [];
    let existIndex = names.indexOf(name);

    if (existIndex == -1) names.push(name);
    else names.splice(existIndex, 1);

    this.queriesDidChange({amenities: names.join(",")});
  }

  toggleFilter(e) {
    e.preventDefault();
    const isOpen = !this.state.isOpenFilter;
    if (isOpen) {
      // deep copy
      this.pendingState = Object.assign({}, this.state);
    } else {
      this.setState(this.pendingState);
    }
    this.setState({isOpenFilter: isOpen});

  }

  showMobileSearchFilter() {
    $(document).trigger('showMobileSearchFilter', [this.state]);
  }

  clickMapMoveSearchButton(isChecked) {
    this.setState({
      isCheckedMapMoveSearch: isChecked,
    });
  }

  clickMapReloadSearchButton() {
    if (!this.state.isCheckedMapMoveSearch) {
      let state = {};
      let geocodes = null;
      if (this.state.geocode == null) {
        // エリア検索→マップ移動→クリア→再検索でエラーにならないようにデフォルト値を入れる
        geocodes = [SMMapHelper.defaultLatitude(), SMMapHelper.defaultLongitude(), SMMapHelper.getRadiusByZoom(8)];
      } else {
        geocodes = this.state.geocode.split(',');
      }
      let lat = '';
      let lng = '';
      let radius = '';

      // 初回にZoomして再検索をかけた時にエラーにならないように
      if (
        this.state.temporaryLatitude != null &&
        this.state.temporaryLongitude != null
      ) {
        lat = this.state.temporaryLatitude;
        lng = this.state.temporaryLongitude;
      } else {
        lat = geocodes[0];
        lng = geocodes[1];
      }

      if (this.state.temporaryZoom) {
        radius = SMMapHelper.getRadiusByZoom(this.state.temporaryZoom);
      } else {
        radius = (geocodes.length == 3) ? parseFloat(geocodes[2]) : SMMapHelper.getRadiusByZoom(8);
      }

      state.geocode = SMMapHelper.getGeocode(lat, lng, radius);
      state.isFilterByPrefecture = false;
      this.queriesDidChange(state);
    }
  }

  clearMapMovedFlag() {
    this.setState({
      isMovedMap: false,
    });
  }

  formDidSubmit(e) {
    e.preventDefault();
    this.setState({isOpenFilter: false});
    setTimeout(()=>{
      this.requestResource();
    }, 1);
    SMTrackHelper.pageView();
  }

  hideAmenityFilter(e) {
    this.manageSelectedAmenities($(e.currentTarget).data('amenity'));
  }

  render() {
    const queries = this.toQuery();
    const listStyle = this.state.isOpenFilter ? {display: 'none'} : {};
    let amenityNames = this.state.amenities ? this.state.amenities.split(",") : [];

    let filterCount = amenityNames.length;
    if (this.state.keyword) filterCount++;

    return(
      <div className="site-main">
        <SMSearchListFormView
          eventType={this.state.eventType}
          priceType={this.state.priceType}
          location={this.state.location}
          capacity={this.state.capacity}
          startedAt={this.state.startedAt}
          startedHour={this.state.startedHour}
          endedAt={this.state.endedAt}
          endedHour={this.state.endedHour}
          minPrice={this.state.minPrice}
          maxPrice={this.state.maxPrice}
          minCapacity={this.state.minCapacity}
          maxCapacity={this.state.maxCapacity}
          stayCheckinAt={this.state.stayCheckinAt}
          stayCheckoutAt={this.state.stayCheckoutAt}
          eventTypeList={this.props.eventTypeList}
          capacityList={this.props.capacityList}
          hasDirectReservationPlans={this.state.hasDirectReservationPlans}
          filterCount={filterCount}
          delegate={this} />
        <div className="search-list">
          <div className="search-list__main-tab">
            <ul className="sm__search-tab">
              <li><a onClick={this.changeTabMobile.bind(this, 1)} href="#" className={this.state.mobileTabIndex != 2 ? "is-current" : ""}>一覧で見る</a></li>
              <li><a onClick={this.changeTabMobile.bind(this, 2)} href="#" className={this.state.mobileTabIndex == 2 ? "is-current" : ""}>地図で見る</a></li>
            </ul>
          </div>
          <div style={{display: !this.state.isTabView || this.state.mobileTabIndex == 1 ? 'block' : 'none'}} ref="listScroller" className="search-list__main">
            {(()=>{
              if (!this.state.isOpenFilter) return null;
              return (
                <CSSTransitionGroup transitionName="js-initial-animation"
                  transitionAppear={true}
                  transitionAppearTimeout={300}
                  transitionEnter={false}
                  transitionLeave={false}>

                  <div className="search-filter-mod search-filter-mod-side">
                    <div className="search-box">
                      <div className="search-box__option">
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-xs-12 col-sm-11 col-md-8">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="search-box__option">
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-xs-12">
                              <div className="search-change__keyword sm-hide">
                                <div className="row">
                                  <h2 className="search-change__main-title search-change__main-title-keyword col-xs-12">キーワード</h2>
                                  <div className="col-xs-12 col-sm-6">
                                    <Textfield
                                      type="text"
                                      name="keyword"
                                      onChange={this.keywordDidChange.bind(this)}
                                      value={this.state.keyword}
                                      className="w100pa"
                                      label="古民家 おしゃれ" />
                                  </div>
                                </div>
                              </div>

                              <div className="search-change__discount">
                                <div className="row">
                                  <div className="col-xs-12">
                                    <h2 className="search-change__main-title">直前割</h2>
                                    <div className="row">
                                      <ul className="search-change__option">
                                        <li className="search-change__option-checkbox col-xs-12">
                                          <input type="checkbox" value={true} id="has_last_minute_discount_plans" name="has_last_minute_discount_plans"
                                            checked={this.state.hasLastMinuteDiscountPlans == true}
                                            onChange={this.lastMinuteDiscountDidSelect.bind(this)} />
                                          <label htmlFor="has_last_minute_discount_plans" className="form-checkbox__s">
                                            <i className="icon-spm-discount search-change__discount-icon"></i>直前割対応プランあり
                                            <span className="mod-evaluate__help ml5 sm-hide">
                                              <i className="fa fa-question-circle"></i>
                                              <span className="mod-tooltip mod-evaluate__help-tooltip">
                                                <span className="baloon baloon-top user-detail-baloon mod-tooltip__detail mod-evaluate__help-baloon">
                                                  <span className="baloon-inner">利用日から5日前までの予約で割引があるプランを持つスペースです。</span>
                                                </span>
                                              </span>
                                            </span>
                                          </label>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="search-change__others">
                                <div className="row">
                                  <div className="search-change__amenity">
                                    <h2 className="search-change__main-title col-xs-12">アメニティ・設備</h2>
                                    {this.amenityList.map((amenity)=>{
                                      if (this.props.eventType == 'stay') {
                                        if (amenity.amenity_type == SMConst.AmenityType.Rental) return null;
                                      } else {
                                        if (amenity.amenity_type == SMConst.AmenityType.Stay) return null;
                                      }
                                      const id = "form-amenity__checkbox" + amenity.id;
                                      const checked = amenityNames.indexOf(amenity.name) != -1;
                                      return (
                                        <div key={id} className="search-change__amenity-checkbox col-xs-6 col-sm-4 col-md-4">
                                          <input type="checkbox" checked={checked} value={amenity.name} id={id} onChange={this.amenityDidSelect.bind(this)} />
                                          <label htmlFor={id} className="form-checkbox__s">{amenity.name_text}</label>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                                {(()=>{
                                  // spaceTypeありで検索を始めた人は指定なしを選んでもフォームが消えないように
                                  // ここはpropsで有無を判断している
                                  if (!this.props.spaceType) return null;
                                  return (
                                    <div className="row">
                                      <div className="search-change__amenity">
                                        <h2 className="search-change__main-title search-change__main-title-keyword col-xs-12">スペースタイプ</h2>
                                        <div className="col-xs-12 col-sm-6">
                                          <div className="mdl-textfield mdl-textfield--floating-label is-focused w100pa">
                                            <span className="service-select material-select">
                                              <select
                                                name="space_type"
                                                value={this.state.spaceType}
                                                className="service-select__purpose w100pa"
                                                onChange={this.spaceTypeDidSelect.bind(this)}>
                                                {SMRenderHelper.renderSpaceTypeOptions(this.props.spaceTypeList)}
                                              </select>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })()}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="search-box__button-area js-search-box__button-area">
                        <div className="container-fluid">
                          <div className="row">
                            <form onSubmit={this.formDidSubmit.bind(this)}>
                              <div className="search-box-button">
                                <input onClick={this.toggleFilter.bind(this)} className="form-btn form-btn__gray form-btn-m form-btn-search" type="button" value="キャンセル" />
                                <input className="form-btn form-btn__blue form-btn-m form-btn-search" type="submit" value="保存して検索する" />
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </CSSTransitionGroup>
              );
            })()}

            <div ref="listContainer" className="search-list__main-result clearfix" style={listStyle}>
              <div className="search-list__container">
                <div className="search-list__sort">
                  <span className="service-select">
                    <SMSearchListSortView selectedValue={this.state.sort} delegate={this} />
                  </span>
                </div>
                <div className="pc-hide__sm-show sm__search-list__narrow">
                  <a href="#" onClick={this.showMobileSearchFilter.bind(this)} className="search-list__narrow-button button-blue">検索条件を変更</a>
                </div>
                <div className="search-list__head">
                  <h1 className="search-list__head-title">スペース検索結果</h1>
                  <span className="search-list__head-number">{this.state.totalCount}件</span>
                  {(()=>{
                    if (amenityNames.length == 0) return null;
                    return (
                      <ul className="active-filter-name">
                        {amenityNames.map((name, index)=>{
                          let amenity;
                          this.props.amenityList.some((a)=>{
                            if (name == a.name) {
                              amenity = a;
                              return true;
                            }
                          });
                          return (
                            <li key={name} className="active-filter-name__list">
                              <a href="#" onClick={this.hideAmenityFilter.bind(this)} data-amenity={name} className="active-filter-name__item">
                                <i className="fa fa-remove active-filter-name__icon"></i>
                                <span className="active-filter-name__text">{amenity.name_text}</span>
                              </a>
                            </li>
                          );
                        })}
                      </ul>
                    );
                  })()}
                </div>

                {(()=>{
                  if (this.state.listItems.length == 0) {
                    return(
                      <div className="search-list__0num">
                        <p className="mb40">データがみつかりませんでした。<br />検索条件を変更し、もう一度検索してみてください。</p>
                      </div>
                    );
                  }
                  return(
                    <div className="units-list clear">
                      <ul className="row">
                        {this.state.listItems.map((room, index) => {
                          return (
                            <SMSearchListTableRow
                              key={room.id}
                              room={room}
                              noRoomImage={this.props.noRoomImage}
                              showBaloon={true}
                              rowIndex={index}
                              canSlide={true}
                              queries={queries}
                              searchSessionId={this.state.searchSessionId}
                              delegate={this}
                              latestUpdatedFavoriteList={this.state.latestUpdatedFavoriteList} />
                          );
                        })}
                      </ul>
                    </div>
                  );
                })()}

                <SMSearchPagerView
                  delegate={this}
                  totalCount={this.state.totalCount}
                  currentPage={this.state.currentPage}
                  perPage={this.props.perPage}
                  links={this.state.links} />
              </div>
            </div>
          </div>
          {(()=>{
            if (this.state.isTabView && this.state.mobileTabIndex != 2) return null;
            return (
              <div
                style={{display: 'block'}}
                className="search-list__map">
                <SMSearchMapView
                  rooms={this.state.listItems}
                  geocode={this.state.geocode}
                  location={this.state.location}
                  currentUser={this.props.currentUser}
                  mouseEnterRoom={this.state.mouseEnterRoom}
                  isMovedMap={this.state.isMovedMap}
                  searchSessionId={this.state.searchSessionId}
                  delegate={this} />
              </div>
            );
          })()}
        </div>
        <SMUFavoriteListSelectView
          room={this.state.targetFavoriteRoom}
          delegate={this}
          user={this.props.currentUser}
          isOpen={this.state.isSMUFavoriteListSelectViewOpen}
          noFavoriteListImage={this.props.noFavoriteListImage} />
      </div>
    );
  }
}
export default SMSearchListView;



// WEBPACK FOOTER //
// ./app/javascript/components/search/SMSearchListView.jsx